import React from "react";
import { Video, Play, MessageCircle } from "lucide-react";
import { toEmbedSrc, VIDEO_URL, waHref } from "./utils";

export default function VideoSection() {
  const embed = toEmbedSrc(VIDEO_URL);
  return (
    <section id="video" className="py-20 max-w-5xl mx-auto px-6">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-600/15 border border-red-800 text-red-300 text-xs font-semibold uppercase tracking-wider mb-4">
          <Video size={12} /> 5-minute walkthrough
        </div>
        <h2 className="font-heading text-4xl md:text-5xl font-black uppercase">See it in action</h2>
        <p className="text-slate-400 mt-3 max-w-xl mx-auto">
          From sign-in to going live on YouTube — every feature demonstrated on a real match.
        </p>
      </div>
      <div className="relative rounded-2xl overflow-hidden border border-slate-800 shadow-2xl bg-slate-900">
        {embed ? (
          <div className="aspect-video">
            <iframe src={embed} title="Cricket Graphics Studio walkthrough"
              data-testid="landing-video-embed"
              allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
              className="w-full h-full border-0" />
          </div>
        ) : (
          <div className="aspect-video flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 gap-3 p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-slate-800 flex items-center justify-center">
              <Play size={32} className="text-slate-500 ml-1" />
            </div>
            <div className="font-heading text-2xl font-bold uppercase">Walkthrough video</div>
            <p className="text-slate-400 max-w-md text-sm">
              Record with Loom using the 5-min script (available on the admin dashboard),
              then set <code className="bg-slate-800 px-1.5 py-0.5 rounded text-xs">REACT_APP_WALKTHROUGH_VIDEO_URL</code>
              to your Loom or YouTube link in <code className="bg-slate-800 px-1.5 py-0.5 rounded text-xs">frontend/.env</code>.
            </p>
            <a href={waHref("Hi! Can I get a demo of Cricket Graphics Studio?")} target="_blank" rel="noreferrer"
              data-testid="video-placeholder-wa"
              className="mt-2 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-sm font-semibold">
              <MessageCircle size={14} /> Ask for a live demo
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
